/* eslint-disable max-len */
import React from 'react';
import { AccountHeaderBlock } from '../../account/AccountHeaderBlock';
import { PlanStateHeaderBlock } from '../../account/PlanStateHeaderBlock';
import { Page2 } from '../../common/Page2';
import { Flexer } from '../elements/LayoutElements';
import { TemplateGalleryView } from './gallery/TemplateGalleryView';

export const TemplatesView = () => {

    return <Page2.Scroll>
        <Page2.Header>
            <Page2.Title size="2xl">Template Gallery</Page2.Title>
            <Page2.HeaderRight>
                <PlanStateHeaderBlock />
                <AccountHeaderBlock />
            </Page2.HeaderRight>
        </Page2.Header>
        <Page2.Content>
            <Flexer height="1.5" />
            <TemplateGalleryView />
        </Page2.Content>
    </Page2.Scroll>;
};

{/* <Observer store={useResolve(WorkspaceModel)} render={({ joined, boards, folders }) => */ }

